import { TmcContextService } from './../../../tmc-context.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { StructureSelectionService } from '../../structure-selection-dialog/structure-selection-dialog-service';
import { StructureSelection } from '../../structure-selection.model';

@Component({
    selector: 'app-structure-selection-field',
    templateUrl: './structure-selection-field.component.html',
    styleUrls: ['./structure-selection-field.component.scss']
})
export class StructureSelectionFieldComponent {

    detailsFormGroup = new FormGroup({});

    selection: StructureSelection;

    value: string;

    @Input('selection') set setSelection(selection: StructureSelection) {
        this.selection = selection;
    }

    @Output() selectionChanged = new EventEmitter<StructureSelection>();

    constructor(
        private tmcContextService: TmcContextService,
        private structureSelectionService: StructureSelectionService
    ) {
        this.detailsFormGroup.addControl('value', new FormControl(null, []));
        this.detailsFormGroup.controls.value.disable({ onlySelf: true, emitEvent: false });
    }

    public doSelection() {
        this.structureSelectionService.selectStationSetOrStation(new StructureSelection()).subscribe(
            result => {
                if (result != null) {
                    const selection: StructureSelection = result;
                    this.selection = selection;
                } else {
                    this.selection = null;
                }
                this.selectionChanged.next(this.selection);
                this.updateValueLabel();
            }
        );
    }

    private updateValueLabel() {
        if (this.selection != null) {
            const values = new Array<string>();
            if (this.selection.stationGroupId != null) {
                values.push(this.tmcContextService.findStationGroupById(this.selection.stationGroupId).name);
            }
            if (this.selection.stationSetId != null) {
                values.push(this.tmcContextService.findStationSetById(this.selection.stationSetId).name);
            }
            if (this.selection.stationId != null) {
                values.push(this.tmcContextService.findStationById(this.selection.stationId).name);
            }
            const value = values.filter(v => v != null && v.length > 0).join(' / ');
            this.detailsFormGroup.patchValue({ value });
        } else {
            this.detailsFormGroup.patchValue({ value: null });
        }
    }
}
